import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/locations/$locationId` activates the location-record
// column (col 2). The Locations LAYOUT route (locations.tsx) reads `$locationId`
// from the leaf match and renders every column via ColumnLayout. Mirrors
// lodging/$bookingId + forms/$formId.
export const Route = createFileRoute("/$orgSlug/$eventSlug/locations/$locationId")({
  component: () => null,
})
